import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
async function getOrgId(APIbaseUrl) {
  try {
    const {
      data
    } = await GraniteAPIClient(APIbaseUrl).get('iframe/');
    return data.client_id;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function validateUser(payload, APIbaseUrl) {
  try {
    const {
      data
    } = await GraniteAPIClient(APIbaseUrl).post('validate-user/', payload);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
export default {
  getOrgId,
  validateUser
};